module.exports = __webpack_public_path__ + "img/R05_06 2.59166152.jpg";